export default  {
    template: require('../views/brandingBanner.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/brandingBanner.component.js